import React, {Component, useState, useRef, useEffect, useCallback} from 'react'
import {
    Box,
    Grid,
    GridItem,
    SimpleGrid,
    FormControl,
    Input,
    HStack,
    VStack,
    Button,
    Card,
    Text,
    CardBody,
    Heading,
    Divider,
    Editable,
    EditablePreview,
    EditableInput,
    AlertDialog,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogBody,
    AlertDialogFooter,
    CardHeader,
    Select,
    Slider,
    SliderTrack,
    SliderFilledTrack,
    SliderThumb,
    Tooltip,
    Collapse,
    FormLabel,
    NumberInput,
    NumberInputField,
    NumberInputStepper,
    NumberIncrementStepper,
    NumberDecrementStepper,
    Portal,
    Spinner,
  } from '@chakra-ui/react';
import { useOutletContext, useParams } from "react-router-dom"
import { CloseIcon, DeleteIcon, SettingsIcon } from '@chakra-ui/icons';

import Sidebar from '../Sidebar/Sidebar';
import Navigation from '../Navigation/Navigation';

function ChapterIndexWrapper() {
  const {
    state,
    onRouteChange,
    onLogOut,
    onFormTextChange,
    onFormTextChangeUpdate,
    onFormTextChangeChapterTitle,
    onGeneratePage,
    generateText,
    onSaveSnippet,
    onViewChapter,
    onEditSnippet,
    onCancelEditSnippet,
    onDeleteSnippet,
    onDeleteChapter,
    onCreateSnippet,
    onCreateChapter,
    onSaveChapterTitle,
    onRewriteText,
    isAuthenticated
  } = useOutletContext()
  const { chapterId } = useParams()
  useEffect(() => {
    onViewChapter(chapterId)
  }, [chapterId, onViewChapter])
  return (
    <ChapterIndex
      key = {chapterId}
      state = {state}
      onRouteChange = {onRouteChange}
      onLogOut  = {onLogOut}
      onFormTextChange  = {onFormTextChange}
      onFormTextChangeUpdate  = {onFormTextChangeUpdate}
      onFormTextChangeChapterTitle  = {onFormTextChangeChapterTitle}
      onGeneratePage  = {onGeneratePage}
      generateText  = {generateText}
      onSaveSnippet = {onSaveSnippet}
      onViewChapter = {onViewChapter}
      onEditSnippet = {onEditSnippet}
      onCancelEditSnippet = {onCancelEditSnippet}
      onDeleteSnippet = {onDeleteSnippet}
      onDeleteChapter = {onDeleteChapter}
      onCreateSnippet = {onCreateSnippet}
      onCreateChapter = {onCreateChapter}
      onSaveChapterTitle = {onSaveChapterTitle}
      onRewriteText = {onRewriteText}
      isAuthenticated = {isAuthenticated}
    />
  )
}

function ChapterIndex({
  key,
  chapterId,
  state,
  onRouteChange,
  onLogOut,
  onFormTextChange,
  onFormTextChangeUpdate,
  onFormTextChangeChapterTitle,
  onGeneratePage,
  generateText,
  onSaveSnippet,
  onViewChapter,
  onEditSnippet,
  onCancelEditSnippet,
  onDeleteSnippet,
  onDeleteChapter,
  onCreateSnippet,
  onCreateChapter,
  onSaveChapterTitle,
  onRewriteText,
  isAuthenticated
}) {
      return (
        <>
        <Grid templateColumns="repeat(48, 1fr)" bg="#F5F3F0">
        <GridItem
          as="aside"
          colSpan="7"
          minHeight="100vh"
          position="sticky"
          top="0"
          alignSelf="start"
          minW="125px"
          bg="white"
          borderRight="1px solid"
          borderColor="#E4E4E7"
          pt="16px"
        >
        <Sidebar
        state = {state}
        onRouteChange = {onRouteChange}
        onViewChapter = {onViewChapter}
        onDeleteChapter = {onDeleteChapter}
        onGeneratePage = {onGeneratePage}
        onCreateChapter = {onCreateChapter}
        onDeleteSnippet = {onDeleteSnippet}
        onSaveChapterTitle = {onSaveChapterTitle}
        onFormTextChangeUpdate = {onFormTextChangeUpdate}
        />
        </GridItem>
        <GridItem
        as="main"
        colSpan="41"
        >
        <Navigation
          bg="#ffffff"
          state={state}
          onRouteChange={onRouteChange}
          onLogOut={onLogOut}
          isAuthenticated={isAuthenticated}
        />
        <SimpleGrid p ="10px" minChildWidth = "250px">
        <Box  display="flex" alignItems={'center'} justifyContent={'center'}>
        <VStack>
          <EditableHeading
            title = {state.chapter.chapter_title}
            chapterId = {state.chapter.chapter_id}
            updates = {state.chapter.updates}
            onSaveChapterTitle = {onSaveChapterTitle}
            onFormTextChangeChapterTitle = {onFormTextChangeChapterTitle}
            state = {state}
            />
          <Snippets
            state = {state}
            onFormTextChange = {onFormTextChange}
            generateText = {generateText}
            onDeleteSnippet = {onDeleteSnippet}
            onFormTextChangeUpdate = {onFormTextChangeUpdate}
            onSaveSnippet = {onSaveSnippet}
            onEditSnippet = {onEditSnippet}
            onCancelEditSnippet = {onCancelEditSnippet}
            onRewriteText = {onRewriteText}
          />

          {
            state.chapter.is_outline
            ?
            null
            :
            <>
            <Divider borderColor="#E4E4E7"/>
            <Text color="#A1A1AA">{state.chapter.snippets['nr_words']} words</Text>
            <CustomButton
              text = "New Snippet"
              w = '150px'
              onClick = {() => {onCreateSnippet(state.chapter.chapter_id)}}
            />
            </>
          }


        </VStack>
        </Box>
        </SimpleGrid>
        </GridItem>
        </Grid>
        </>
      )
    }

  function EditableHeading({title, chapterId, updates = {}, onSaveChapterTitle, onFormTextChangeChapterTitle, state}) {

    let newTitle = updates[chapterId]?.title
    let titleEdit = newTitle ?? title
    return (
      <Editable
        value={titleEdit}
        onSubmit = {(newTitle) => {
          if (newTitle !== title) {
              onSaveChapterTitle(chapterId)
            }
          }
        }
        fontSize="3xl"
        fontStyle="oblique"
        fontWeight="700"
        textAlign="center"
        color="#1A1A1A"
      >

      <Heading as="h1">
        <EditablePreview />
      </Heading>
      <EditableInput
        onChange = {
          (event) => {
            onFormTextChangeChapterTitle('chapter', chapterId, 'title', event.target.value)
          }
        }
      />
    </Editable>
    )
  }

  class Snippets extends Component {
    render() {
      let snippets = this.props.state.chapter.snippets
      return (
        <>
        {snippets['exists'] === true
          ?
          snippets['items'].map(snippet => (
            <Snippet
              id = {snippet.id}
              text = {snippet.text}
              editing_obj = {snippet.editing_obj}
              snippet = {snippet}
              state = {this.props.state}
              onDeleteSnippet = {this.props.onDeleteSnippet}
              onFormTextChange = {this.props.onFormTextChange}
              onFormTextChangeUpdate = {this.props.onFormTextChangeUpdate}
              generateText = {this.props.generateText}
              onEditSnippet = {this.props.onEditSnippet}
              onSaveSnippet = {this.props.onSaveSnippet}
              onCancelEditSnippet = {this.props.onCancelEditSnippet}
              onRewriteText = {this.props.onRewriteText}
            />
            )
          )
          :
            null
          }
        </>
      )
    }
  }

  class Snippet extends Component {
    render() {
        let editing_obj = this.props.editing_obj
        return (
          <>
            {editing_obj.editing === true
            ?
              <EditingSnippet
                id = {this.props.id}
                editing_obj = {this.props.editing_obj}
                snippet = {this.props.snippet}
                state = {this.props.state}
                onDeleteSnippet = {this.props.onDeleteSnippet}
                onFormTextChange = {this.props.onFormTextChange}
                onFormTextChangeUpdate = {this.props.onFormTextChangeUpdate}
                generateText = {this.props.generateText}
                onSaveSnippet = {this.props.onSaveSnippet}
                onCancelEditSnippet = {this.props.onCancelEditSnippet}
                onRewriteText = {this.props.onRewriteText}
              />
            :
              <SavedSnippet
                id = {this.props.id}
                text = {this.props.text}
                snippet = {this.props.snippet}
                onDeleteSnippet = {this.props.onDeleteSnippet}
                onEditSnippet = {this.props.onEditSnippet}
              />
            }
          </>
        )
    }
}

function EditingSnippet({ id, editing_obj, snippet, state, onDeleteSnippet, onFormTextChange, onFormTextChangeUpdate, generateText, onSaveSnippet, onCancelEditSnippet, onRewriteText }) {
  const [showOptions, setShowOptions] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)
  const [menuPos, setMenuPos] = useState(null)
  const [selectedText, setSelectedText] = useState('')
  const [customInstruction, setCustomInstruction] = useState('')
  const [isRewriting, setIsRewriting] = useState(false)
  const [undoStack, setUndoStack] = useState([])
  const textAreaRef = useRef(null)
  const menuRef = useRef(null)

  const options = state.chapter.updates[id] || {}
  const creativity = options.creativity ?? 50
  const maxWords = options.maxWords ?? 300
  const tone = options.tone ?? ''
  const language = options.language ?? ''
  const writingStyle = options.writingStyle ?? ''
  const pov = options.pov ?? ''
  const model = options.model ?? ''
  const currentText = state.chapter.updates[id]?.text ?? editing_obj.text

  const selectionRange = useRef(null)

  const handleMouseUp = useCallback(() => {
    const textarea = textAreaRef.current
    if (!textarea) return
    if (textarea.selectionStart !== textarea.selectionEnd) {
      const selected = textarea.value.substring(textarea.selectionStart, textarea.selectionEnd).trim()
      if (selected.length > 0) {
        const rect = textarea.getBoundingClientRect()
        selectionRange.current = { start: textarea.selectionStart, end: textarea.selectionEnd }
        setSelectedText(selected)
        setMenuPos({
          top: rect.top + window.scrollY - 10,
          left: rect.left + window.scrollX + (rect.width / 2)
        })
      }
    }
  }, [])

  const handleClickOutside = useCallback((e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setMenuPos(null)
      setSelectedText('')
      setCustomInstruction('')
    }
  }, [])

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [handleClickOutside])

  const handleRewrite = async (instruction) => {
    if (!selectedText || !instruction) return
    setIsRewriting(true)
    const textBefore = currentText
    try {
      const range = selectionRange.current
      await onRewriteText(id, selectedText, currentText, instruction, range)
      setUndoStack(prev => [...prev, textBefore])
    } finally {
      setIsRewriting(false)
      setMenuPos(null)
      setSelectedText('')
      setCustomInstruction('')
      selectionRange.current = null
    }
  }

  const handleGenerate = async () => {
    const textBefore = currentText
    await generateText(id)
    setUndoStack(prev => [...prev, textBefore])
  }

  const handleUndo = () => {
    if (undoStack.length === 0) return
    const previousText = undoStack[undoStack.length - 1]
    setUndoStack(prev => prev.slice(0, -1))
    onFormTextChangeUpdate('chapter', id, 'text', previousText)
    onSaveSnippet(id, previousText)
  }

  const presetOptions = [
    { label: 'More dramatic', instruction: 'Make this more dramatic and intense' },
    { label: 'More concise', instruction: 'Make this more concise while keeping the meaning' },
    { label: 'Better dialogue', instruction: 'Improve the dialogue to feel more natural and snappy' },
    { label: 'More descriptive', instruction: 'Add more vivid sensory details and description' },
    { label: 'Fix grammar', instruction: 'Fix grammar, flow, and polish the prose' },
  ]

  const selectStyles = {
    size: "sm",
    bg: "white",
    borderColor: "#E4E4E7",
    borderRadius: "md",
    _hover: { borderColor: '#A1A1AA' },
    _focus: { borderColor: '#E05252', boxShadow: '0 0 0 1px #E05252' },
  }

  return (
    <>
    <Card
    bg="white"
    w='42vw'
    color="#1A1A1A"
    p="28px"
    display="flex"
    borderRadius="xl"
    alignItems={'center'}
    justifyContent={'center'}
    boxShadow="0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)"
    border="1px solid"
    borderColor="#E4E4E7"
    >
    <VStack w="100%" spacing="16px">
      <FormControl isRequired display="flex" justifyContent={'center'}>
        <Input
          h='56px'
          w='100%'
          placeholder='Type your instructions...'
          bg='#FAFAF9'
          border="1px solid"
          borderColor="#E4E4E7"
          rounded='xl'
          fontSize="md"
          _placeholder={{ color: '#A1A1AA' }}
          _hover={{ borderColor: '#A1A1AA' }}
          _focus={{ borderColor: '#E05252', boxShadow: '0 0 0 1px #E05252' }}
          onChange = {
              (event) => {
                  onFormTextChangeUpdate('chapter', id, 'prompt', event.target.value)
              }
          }
        />
      </FormControl>

      <Box w="100%">
        <Button
          size="sm"
          variant="ghost"
          leftIcon={<SettingsIcon />}
          color="#A1A1AA"
          fontWeight="500"
          fontSize="xs"
          onClick={() => setShowOptions(!showOptions)}
          _hover={{ bg: '#FAFAF9', color: '#52525B' }}
          transition="all 0.2s"
        >
          {showOptions ? 'Hide Options' : 'Generation Options'}
        </Button>
      </Box>

      <Collapse in={showOptions} animateOpacity style={{ width: '100%' }}>
        <Box
          bg="#FAFAF9"
          p="20px"
          borderRadius="lg"
          border="1px solid"
          borderColor="#E4E4E7"
          w="100%"
        >
          <SimpleGrid columns={2} spacing="16px">
            <FormControl>
              <FormLabel fontSize="xs" fontWeight="600" color="#A1A1AA" textTransform="uppercase" letterSpacing="wide" mb="6px">Tone</FormLabel>
              <Select
                {...selectStyles}
                placeholder="Default"
                value={tone}
                onChange={(e) => onFormTextChangeUpdate('chapter', id, 'tone', e.target.value)}
              >
                <option value="dramatic">Dramatic</option>
                <option value="humorous">Humorous</option>
                <option value="dark">Dark</option>
                <option value="lighthearted">Lighthearted</option>
                <option value="suspenseful">Suspenseful</option>
                <option value="melancholic">Melancholic</option>
                <option value="romantic">Romantic</option>
                <option value="whimsical">Whimsical</option>
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel fontSize="xs" fontWeight="600" color="#A1A1AA" textTransform="uppercase" letterSpacing="wide" mb="6px">Writing Style</FormLabel>
              <Select
                {...selectStyles}
                placeholder="Default"
                value={writingStyle}
                onChange={(e) => onFormTextChangeUpdate('chapter', id, 'writingStyle', e.target.value)}
              >
                <option value="descriptive">Descriptive</option>
                <option value="minimalist">Minimalist</option>
                <option value="literary">Literary</option>
                <option value="fast-paced">Fast-paced</option>
                <option value="dialogue-heavy">Dialogue-heavy</option>
                <option value="stream-of-consciousness">Stream of Consciousness</option>
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel fontSize="xs" fontWeight="600" color="#A1A1AA" textTransform="uppercase" letterSpacing="wide" mb="6px">Point of View</FormLabel>
              <Select
                {...selectStyles}
                placeholder="Default"
                value={pov}
                onChange={(e) => onFormTextChangeUpdate('chapter', id, 'pov', e.target.value)}
              >
                <option value="first-person">First Person</option>
                <option value="third-person-limited">Third Person Limited</option>
                <option value="third-person-omniscient">Third Person Omniscient</option>
                <option value="second-person">Second Person</option>
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel fontSize="xs" fontWeight="600" color="#A1A1AA" textTransform="uppercase" letterSpacing="wide" mb="6px">Language</FormLabel>
              <Select
                {...selectStyles}
                placeholder="English"
                value={language}
                onChange={(e) => onFormTextChangeUpdate('chapter', id, 'language', e.target.value)}
              >
                <option value="english">English</option>
                <option value="spanish">Spanish</option>
                <option value="french">French</option>
                <option value="german">German</option>
                <option value="dutch">Dutch</option>
                <option value="italian">Italian</option>
                <option value="portuguese">Portuguese</option>
                <option value="japanese">Japanese</option>
                <option value="chinese">Chinese</option>
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel fontSize="xs" fontWeight="600" color="#A1A1AA" textTransform="uppercase" letterSpacing="wide" mb="6px">Model</FormLabel>
              <Select
                {...selectStyles}
                value={model || 'claude-sonnet-4-6'}
                onChange={(e) => onFormTextChangeUpdate('chapter', id, 'model', e.target.value)}
              >
                <option value="claude-sonnet-4-6">Claude Sonnet 4.6 (default)</option>
                <option value="claude-opus-4-6">Claude Opus 4.6</option>
                <option value="claude-haiku-4-5">Claude Haiku 4.5</option>
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel fontSize="xs" fontWeight="600" color="#A1A1AA" textTransform="uppercase" letterSpacing="wide" mb="6px">
                Creativity: {creativity}%
              </FormLabel>
              <Box pt="6px">
              <Slider
                min={0}
                max={100}
                step={5}
                value={creativity}
                onChange={(val) => onFormTextChangeUpdate('chapter', id, 'creativity', val)}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                <SliderTrack bg="#E4E4E7" h="6px" borderRadius="full">
                  <SliderFilledTrack bg="#E05252" borderRadius="full" />
                </SliderTrack>
                <Tooltip
                  hasArrow
                  bg="#1A1A1A"
                  color="white"
                  placement="top"
                  isOpen={showTooltip}
                  label={`${creativity}%`}
                  borderRadius="md"
                  fontSize="xs"
                >
                  <SliderThumb boxSize="16px" />
                </Tooltip>
              </Slider>
              </Box>
            </FormControl>

            <FormControl>
              <FormLabel fontSize="xs" fontWeight="600" color="#A1A1AA" textTransform="uppercase" letterSpacing="wide" mb="6px">Max Words</FormLabel>
              <NumberInput
                size="sm"
                min={50}
                max={1000}
                step={50}
                value={maxWords}
                onChange={(_, val) => onFormTextChangeUpdate('chapter', id, 'maxWords', val || 300)}
              >
                <NumberInputField bg="white" borderColor="#E4E4E7" borderRadius="md" _hover={{ borderColor: '#A1A1AA' }} _focus={{ borderColor: '#E05252', boxShadow: '0 0 0 1px #E05252' }} />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            </FormControl>
          </SimpleGrid>
        </Box>
      </Collapse>

      <Box w="100%" pt="4px">
          <CustomButton
          w='100%'
          text = "Generate"
          onClick = {() => {handleGenerate()}}
          isLoading = {state.isGenerating}
          disabled = {state.isGenerating}
          />
        </Box>
        <Divider borderColor="#E4E4E7"/>
        <CardBody p="0" w="100%">
          <Box position="relative">
            <textarea
              ref={textAreaRef}
              value={currentText}
              onChange={(e) => onFormTextChangeUpdate('chapter', id, 'text', e.target.value)}
              onBlur={(e) => {
                if (menuRef.current && menuRef.current.contains(e.relatedTarget)) {
                  return
                }
                if (currentText !== editing_obj.text) {
                  onSaveSnippet(id)
                }
              }}
              onMouseUp={handleMouseUp}
              style={{
                width: '100%',
                minHeight: '30vh',
                fontSize: '16px',
                color: '#1A1A1A',
                whiteSpace: 'pre-wrap',
                padding: '16px',
                border: '1px solid #E4E4E7',
                borderRadius: '12px',
                backgroundColor: '#FAFAF9',
                resize: 'vertical',
                fontFamily: 'inherit',
                lineHeight: '1.7',
                outline: 'none',
                transition: 'border-color 0.2s, box-shadow 0.2s',
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#E05252'
                e.target.style.boxShadow = '0 0 0 1px #E05252'
              }}
              onFocusCapture={() => {}}
            />
            <HStack position="absolute" top="8px" right="8px" spacing="8px">
              {undoStack.length > 0 && (
                <Button
                  size="xs"
                  variant="ghost"
                  color="#A1A1AA"
                  fontWeight="normal"
                  fontSize="xs"
                  _hover={{ color: '#E05252', bg: '#FEF2F2' }}
                  onClick={handleUndo}
                >
                  Undo
                </Button>
              )}
              <CloseIcon
                boxSize="10px"
                color="#A1A1AA"
                cursor='pointer'
                _hover={{ color: '#52525B' }}
                onClick={() => {onCancelEditSnippet(id)}}
              />
            </HStack>
          </Box>
        </CardBody>
      </VStack>
    </Card>

    {menuPos && selectedText && (
      <Portal>
        <Box
          ref={menuRef}
          position="absolute"
          top={`${menuPos.top}px`}
          left={`${menuPos.left}px`}
          transform="translate(-50%, -100%)"
          bg="white"
          boxShadow="0 4px 24px rgba(0,0,0,0.1), 0 1px 2px rgba(0,0,0,0.04)"
          borderRadius="xl"
          border="1px solid"
          borderColor="#E4E4E7"
          p="14px"
          zIndex={1000}
          minW="220px"
          maxW="320px"
        >
          {isRewriting ? (
            <VStack py="10px">
              <Spinner size="md" color="#E05252" />
              <Text fontSize="sm" color="#52525B">Rewriting...</Text>
            </VStack>
          ) : (
            <VStack spacing="6px" align="stretch">
              <Text fontSize="xs" color="#A1A1AA" fontWeight="700" textTransform="uppercase" letterSpacing="wide">
                Rewrite selection
              </Text>
              <Box
                bg="#FEF2F2"
                borderRadius="md"
                px="10px"
                py="6px"
                maxH="80px"
                overflowY="auto"
                border="1px solid"
                borderColor="#E4E4E7"
              >
                <Text fontSize="xs" color="#52525B" noOfLines={3} fontStyle="italic">
                  "{selectedText}"
                </Text>
              </Box>
              {presetOptions.map((opt) => (
                <Button
                  key={opt.label}
                  size="sm"
                  variant="ghost"
                  justifyContent="flex-start"
                  fontWeight="normal"
                  color="#1A1A1A"
                  _hover={{ bg: '#FEF2F2', color: '#C94545' }}
                  onClick={() => handleRewrite(opt.instruction)}
                >
                  {opt.label}
                </Button>
              ))}
              <Divider borderColor="#E4E4E7" />
              <HStack>
                <Input
                  size="sm"
                  placeholder="Custom instruction..."
                  value={customInstruction}
                  onChange={(e) => setCustomInstruction(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && customInstruction.trim()) {
                      handleRewrite(customInstruction)
                    }
                  }}
                  bg="#FAFAF9"
                  borderRadius="md"
                  borderColor="#E4E4E7"
                />
                <Button
                  size="sm"
                  bg="#E05252"
                  color="white"
                  _hover={{ bg: '#C94545' }}
                  borderRadius="md"
                  onClick={() => handleRewrite(customInstruction)}
                  isDisabled={!customInstruction.trim()}
                >
                  Go
                </Button>
              </HStack>
            </VStack>
          )}
        </Box>
      </Portal>
    )}
    </>
  )
}


class SavedSnippet extends Component {
  render() {
    return (
      <>
      <Card
        variant="unstyled"
        w='42vw'
        p="20px"
        display="flex"
        flexDirection="column"
        alignItems="stretch"
        borderRadius="xl"
        border="1px solid"
        borderColor="transparent"
        _hover={{ bg: "#FAFAF9", borderColor: "#E4E4E7" }}
        cursor='pointer'
        transition="all 0.2s"
        onClick={() => {this.props.onEditSnippet(this.props.id)}}
      >
      <VStack>
        <CardHeader
          display="flex"
          w="100%"
          justifyContent="flex-end"
          alignItems="center"
          py="0"
        >
              {
                  this.props.snippet.is_outline
                  ?
                  null
                  :
                  <DeleteSnippetIcon
                  id={this.props.id}
                  onDeleteSnippet={this.props.onDeleteSnippet}
                />
              }
        </CardHeader>
        <CardBody pt="0">
          <Text
            whiteSpace="pre-wrap"
            fontSize="16px"
            color="#1A1A1A"
            className="snippet-text"
            lineHeight="1.85"
          >
            {this.props.text}
          </Text>
        </CardBody>
        </VStack>
      </Card>
    </>
    )
  }
}

const DeleteSnippetIcon = ({ onDeleteSnippet, id }) => {
  const [isOpen, setIsOpen] = useState(false);
  const cancelRef = useRef();

  const openDialog = () => setIsOpen(true);
  const closeDialog = () => setIsOpen(false);

  const handleDelete = (id) => {
    onDeleteSnippet(id);
    closeDialog();
  };

  return (
    <>
      <DeleteIcon
        color = '#E05252'
        cursor='pointer'
        _hover={{ color: '#C94545' }}
        onClick = {(e) => {
          e.stopPropagation();
          openDialog()
        }}
      />

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={closeDialog}
      >
        <AlertDialogOverlay bg="blackAlpha.400" backdropFilter="blur(4px)">
          <AlertDialogContent borderRadius="xl">
            <AlertDialogHeader fontSize="lg" fontWeight="600">
              Delete Snippet
            </AlertDialogHeader>

            <AlertDialogBody color="#52525B">
              Are you sure you want to delete this snippet? This action cannot be undone.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={closeDialog} borderRadius="lg">
                Cancel
              </Button>
              <Button bg="#E05252" color="white" _hover={{ bg: '#C94545' }} borderRadius="lg" onClick = {() => {handleDelete(id)}} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

class CustomButton extends Component {
  render() {
    return (
      <Button
        px={6}
        py={5}
        w={this.props.w}
        fontSize={'sm'}
        fontWeight="600"
        bg={'#E05252'}
        color={'white'}
        borderRadius="xl"
        boxShadow="none"
        letterSpacing="0.02em"
        _hover={{
            bg: '#C94545',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 12px rgba(224, 82, 82, 0.25)',
        }}
        _focus={{
            bg: '#C94545',
        }}
        _active={{
            transform: 'translateY(0)',
        }}
        transition="all 0.2s"
        onClick={this.props.onClick}
        isLoading={this.props.isLoading}
        loadingText="Generating..."
      >{this.props.text}
      </Button>
    )
  }
}





export default ChapterIndexWrapper
